export default __webpack_public_path__ + "static/img22h-327d457dffd31e8117e18fbb54292c92.jpg";